<div class="fast-checkin-duration-container">
  <div class="content-wrapper mt-4">

    <div class="row">
      <div class="col-12">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.shared.fields.zone' | translate }}</span>
              <strong>{{ sessionInfo.zoneName }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.shared.fields.control-plate' | translate }}</span>
              <strong>{{ sessionInfo.controlPlateNumber }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.domain.fast-checkin-session.start-time' | translate }}</span>
              <strong>{{ sessionInfo.startDateTime?.toFormat('dd.MM.yyyy HH:mm') }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.domain.pay-till-now-session.total-price' | translate }}</span>
              <strong class="text-primary">{{ sessionPriceWithCurrency }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if(showReadyToLeaveMessage) {
      <div class="alert alert-success text-center" role="alert">
        {{ 'i18n.domain.pay-till-now.clear-for-departure' | translate: { timestamp: readyToLeaveTimestamp } }}
      </div>
    } @else {
      <div class="button-container">
        <div class="d-grid">
          <button class="btn btn-danger" (click)="payNow.emit()">
            {{ 'i18n.domain.pay-till-now-session.pay-now' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
